"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteSmtpToken = exports.DeleteSmtpToken = exports.DeleteSmtpTokenActionTypes = exports.resetSmtpTokenPassword = exports.ResetSmtpTokenPassword = exports.ResetSmtpTokenPasswordActionTypes = exports.createSmtpToken = exports.CreateSmtpToken = exports.CreateSmtpTokenActionTypes = exports.FetchSmtpTokens = exports.FetchSmtpTokensActionTypes = exports.loadSmtpTokens = exports.SmtpTokensActionTypes = void 0;

var _fluxActions = require("flux-actions");

var _actions = require("settings-ui-sdk/utils/actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _constants = require("./constants");

var SmtpTokensActionTypes = (0, _namespacedKeyMirror.default)({
  LOAD_SMTP_TOKENS: null,
  FETCH_SMTP_TOKENS: null,
  CREATE_SMTP_TOKEN: null,
  RESET_SMTP_TOKEN_PASSWORD: null,
  DELETE_SMTP_TOKEN: null
}, _constants.SMTP_TOKEN);
exports.SmtpTokensActionTypes = SmtpTokensActionTypes;
var loadSmtpTokens = (0, _fluxActions.createAction)(SmtpTokensActionTypes.LOAD_SMTP_TOKENS);
exports.loadSmtpTokens = loadSmtpTokens;
var FetchSmtpTokensActionTypes = (0, _actions.createRequestTypes)(SmtpTokensActionTypes.FETCH_SMTP_TOKENS);
exports.FetchSmtpTokensActionTypes = FetchSmtpTokensActionTypes;
var FetchSmtpTokens = (0, _actions.createRequestActions)(FetchSmtpTokensActionTypes);
exports.FetchSmtpTokens = FetchSmtpTokens;
var CreateSmtpTokenActionTypes = (0, _actions.createRequestTypes)(SmtpTokensActionTypes.CREATE_SMTP_TOKEN);
exports.CreateSmtpTokenActionTypes = CreateSmtpTokenActionTypes;
var CreateSmtpToken = (0, _actions.createRequestActions)(CreateSmtpTokenActionTypes);
exports.CreateSmtpToken = CreateSmtpToken;
var createSmtpToken = (0, _fluxActions.createAction)(SmtpTokensActionTypes.CREATE_SMTP_TOKEN, (0, _actions.mapPayloadTo)('data'));
exports.createSmtpToken = createSmtpToken;
var ResetSmtpTokenPasswordActionTypes = (0, _actions.createRequestTypes)(SmtpTokensActionTypes.RESET_SMTP_TOKEN_PASSWORD);
exports.ResetSmtpTokenPasswordActionTypes = ResetSmtpTokenPasswordActionTypes;
var ResetSmtpTokenPassword = (0, _actions.createRequestActions)(ResetSmtpTokenPasswordActionTypes);
exports.ResetSmtpTokenPassword = ResetSmtpTokenPassword;
var resetSmtpTokenPassword = (0, _fluxActions.createAction)(SmtpTokensActionTypes.RESET_SMTP_TOKEN_PASSWORD, (0, _actions.mapPayloadTo)('data'));
exports.resetSmtpTokenPassword = resetSmtpTokenPassword;
var DeleteSmtpTokenActionTypes = (0, _actions.createRequestTypes)(SmtpTokensActionTypes.DELETE_SMTP_TOKEN);
exports.DeleteSmtpTokenActionTypes = DeleteSmtpTokenActionTypes;
var DeleteSmtpToken = (0, _actions.createRequestActions)(DeleteSmtpTokenActionTypes);
exports.DeleteSmtpToken = DeleteSmtpToken;
var deleteSmtpToken = (0, _fluxActions.createAction)(SmtpTokensActionTypes.DELETE_SMTP_TOKEN, (0, _actions.mapPayloadTo)('data'));
exports.deleteSmtpToken = deleteSmtpToken;